import {Icon} from '@salesforce/retail-react-app/app/components/shared/ui';

/** Checkout order-summary qty stepper icons (Figma 5759:21023 / 5759:25447). */
export function CheckoutQtyMinusIcon(props) {
  return (
    <Icon aria-hidden fill="none" height="16px" viewBox="0 0 17 16" width="17px" {...props}>
      <path
        d="M0.75 8H15.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </Icon>
  );
}

CheckoutQtyMinusIcon.displayName = 'CheckoutQtyMinusIcon';

export function CheckoutQtyPlusIcon(props) {
  return (
    <Icon aria-hidden fill="none" height="17px" viewBox="0 0 17 17" width="17px" {...props}>
      <path
        d="M0.75 8.25H15.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M8.25 0.75V15.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </Icon>
  );
}

CheckoutQtyPlusIcon.displayName = 'CheckoutQtyPlusIcon';
